import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { CloseButton, Container, Content } from './styled'

const Modal = ({ children, isFullHeight = false, onClose, widthDesktop = "500px" }) => {
	useEffect(() => {
		disableBodyScroll(document.body)

		return () => {
			clearAllBodyScrollLocks()
		}
	}, [])

	const modalContent = (
		<Container isFullHeight={isFullHeight} widthDesktop={widthDesktop}>
			<Content isFullHeight={isFullHeight} widthDesktop={widthDesktop}>
				{onClose && <CloseButton onClick={onClose}>×</CloseButton>}
				{children}
			</Content>
		</Container>
	)

	return ReactDOM.createPortal(modalContent, document.body)
}

export default Modal
